'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.NO = exports.FOP = exports.PO = exports.FO = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:18:46Z                      #

// ##############################################################

/**
 * Typ subjektu. @author Pavel Stánek [pavel.stanek@marbes.cz] @since 26.01.2017
 */

/**
 * Fyzická osoba.
 */
var FO = exports.FO = 'FO';

/**
 * Právnická osoba.
 */
var PO = exports.PO = 'PO';

/**
 * Podnikající fyzická osoba.
 */
var FOP = exports.FOP = 'FOP';

/**
 * Neznámá osoba.
 */
var NO = exports.NO = 'NO';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [FO, PO, FOP, NO];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, FO, { caption: 'Fyzická osoba.' }), (0, _defineProperty3.default)(_params, PO, { caption: 'Právnická osoba.' }), (0, _defineProperty3.default)(_params, FOP, { caption: 'Podnikající fyzická osoba.' }), (0, _defineProperty3.default)(_params, NO, { caption: 'Neznámá osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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